import type { SelfContainedCommand } from '../../../../types/commands';
import { automation_list } from './automation_list';
import { automation_create } from './automation_create';
import { automation_update } from './automation_update';
import { automation_delete } from './automation_delete';
import { automation_run } from './automation_run';

export { automation_list, automation_create, automation_update, automation_delete, automation_run };

export const AUTOMATIONS_COMMANDS: SelfContainedCommand[] = [
  automation_list,
  automation_create,
  automation_update,
  automation_delete,
  automation_run,
];
